import { UserFormValues } from './types';

export const emptyToNull = (v: unknown) => {
  if (typeof v === 'string') {
    return v.trim() === '' ? null : v.trim();
  }
  return v;
};
export const toIntOrNull = (v: unknown) => {
  if (v === '' || v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isFinite(n) ? Math.trunc(n) : null;
};

export const toClientField = (key: string): keyof UserFormValues | 'root' => {
  const map: Partial<Record<string, keyof UserFormValues>> = {
    BurnCenterId: 'burnCenterId',
    Name: 'name',
    Nickname: 'nickname',
    PhoneNumber: 'phoneNumber',
    Title: 'title',
    Credentials: 'credentials',
    Email: 'email',
    Role: 'role',
    ReportingRole: 'reportingRole',
    ClinicalStudioRole: 'clinicalStudioRole',
    CanAccessVerification: 'canAccessVerification',
    CanAccessBedEntry: 'canAccessBedEntry',
    CanUpdateTrainingContent: 'canUpdateTrainingContent',
    Active: 'active',
  };
  return map[key] ?? (key.charAt(0).toLowerCase() + key.slice(1) as keyof UserFormValues);
};
